

const SET_IS_FILTER_DATA_LOADING = (state, isLoading) => {
  state.isFilterLoading = isLoading;
};

const FILTER_DATA_UPDATED = (state, data) => {
  state.filterData = data;
};

const FILTER_DATA = (state, data) => {
  state.filterData = data;
};



const SET_IS_INVENTORY_LIST_LOADING = (state, isLoading) => {
  state.isInventoryListLoading = isLoading;
};

const INVENTORY_LIST_UPDATED = (state, data) => {
  state.inventoryList = data;
};

const INVENTORY_LIST = (state, data) => {
  state.inventoryList = data;
};



const SET_DISPLAYED_WARNING_BANNER = (state, pageName) => {
  if (pageName === TAB_INDEX.CLOUD_BILL_DETAIL) {
    state.chargeTableState.cloudBillDetails.displayedWarning = false;
  } else if (pageName === TAB_INDEX.CLOUD_INVOICE_LIST) {
    state.chargeTableState.cloudInvoiceList.displayedWarning = false;
  }
  setValueToStorageByKey(LOCAL_STORAGE_KEY.BILLING_TABLE_STATE, state.chargeTableState);
};

const SET_SELECTED_VENDOR = (state, vendor) => {
  state.selectedVendor = vendor;
};

export default {
  SET_IS_FILTER_DATA_LOADING,
  FILTER_DATA_UPDATED,
  FILTER_DATA,

  SET_IS_INVENTORY_LIST_LOADING,
  INVENTORY_LIST_UPDATED,
  INVENTORY_LIST,

  SET_DISPLAYED_WARNING_BANNER,
  SET_SELECTED_VENDOR
};




// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-inventory/mutations.js